import React from "react";

function RejectXIcon() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 8.25L8.25 14.25M8.25 8.25L14.25 14.25M21.25 11.25C21.25 16.7728 16.7728 21.25 11.25 21.25C5.72715 21.25 1.25 16.7728 1.25 11.25C1.25 5.72715 5.72715 1.25 11.25 1.25C16.7728 1.25 21.25 5.72715 21.25 11.25Z"
        stroke="#F44336"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default RejectXIcon;
